import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames'
import style from './section.css';

export default class Section extends React.Component {
  
  render() {
    let title = null;
    let subtitle = null;
    let header = null;

    if ( this.props.header ) {
      header = <div className={style.header}>{this.props.header}</div>
    } 
    if ( this.props.title ) {
      title = <div className={style.title}>{this.props.title}</div>
    } 
    if ( this.props.subtitle ) {
      subtitle = <div className={style.subtitle}>{this.props.subtitle}</div>
    }
    let headerContent
    if ( header || subtitle || title || this.props.right ) {
      headerContent = (
        <div className={style.headerContent}>
          { this.props.titleOnTop ?
            (
              <div>
                {title}
                {subtitle}
                {header}
              </div>
            ) :
            (
              <div>
                {subtitle}
                {title}
                {header}
              </div>
            ) }
          {this.props.right}
        </div>
      )
    }
    const clazz = classNames( style.section, this.props.className );
    return (
      <div className={clazz}>
        {headerContent}
        {this.props.children}
      </div>
    )
  }
}
